module.exports = __webpack_public_path__ + "static/media/sofienne.6af8136d.jpg";